import React from "react"
import style from "./gallery-new.mod.scss"
import itemStyle from "../elements/gallery-item.mod.scss"
import { GatsbyImage } from "gatsby-plugin-image"

const GalleryNewGroupCard = ({
  id,
  previewItem,
  tagLabel,
  title,
  excerptText,
  hasVideo,
  onClick,
  items,
  elevated,
  hover
}) => {
  const rootMods = [itemStyle["gallery-item"], style.galleryNew__groupCardRoot]
  elevated && rootMods.push(itemStyle["gallery-item--elevated"])
  hover && rootMods.push(itemStyle["gallery-item--hover"])

  return (
    <div
      className={rootMods.filter(Boolean).join(" ")}
      onClick={() => onClick(id, items)}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          onClick(id, items)
        }
      }}
    >
      <div
        className={[
          itemStyle["gallery-item__image"],
          style.galleryNew__groupCardMedia
        ].join(" ")}
      >
        <div className={style.galleryNew__cardImage}>
          {previewItem?.image?.gatsbyImageData && (
            <GatsbyImage
              image={previewItem.image.gatsbyImageData}
              alt={previewItem.image.alt || ""}
              loading="lazy"
            />
          )}
          {hasVideo && (
            <span className={style.galleryNew__playBadge} aria-hidden />
          )}
        </div>
      </div>
      <div className={style.galleryNew__cardBody}>
        {tagLabel && (
          <div className={style.galleryNew__cardTag}>{tagLabel}</div>
        )}
        {title && <h3 className={style.galleryNew__cardTitle}>{title}</h3>}
        {excerptText && (
          <p className={style.galleryNew__cardExcerpt}>{excerptText}</p>
        )}
      </div>
    </div>
  )
}

export default GalleryNewGroupCard
